import React from 'react'
import { Spinner as CoreSpinner, Intent } from '@blueprintjs/core'

export const Spinner = ({ style, size = 60 }) => (
    <div style={Object.assign({}, style)}>
        <CoreSpinner
            intent={Intent.PRIMARY}
            size={size}
        />
    </div>
)